<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <!-- <el-tab-pane label="待审核" name="order1" v-if='false'>
        <audit ref="childRef0" :status="6"></audit>
      </el-tab-pane> -->
      <!-- <el-tab-pane label="全部订单" name="order6">
        <span slot="label">全部订单（{{ tab4 }}）</span>
        <audit ref="childRef0" :status="-1" />
      </el-tab-pane>
      <el-tab-pane label="待付款" name="order2">
        <span slot="label">待付款（{{ tab0 }}）</span>
        <audit ref="childRef1" :status="0" />
      </el-tab-pane>
      <el-tab-pane label="待发货" name="order3">
        <span slot="label">待发货（{{ tab1 }}）</span>
        <audit ref="childRef2" :status="1" />
      </el-tab-pane>
      <el-tab-pane label="待收货" name="order4">
        <span slot="label">待收货（{{ tab2 }}）</span>
        <audit ref="childRef3" :status="2" />
      </el-tab-pane>
      <el-tab-pane label="已完成" name="order5">
        <span slot="label">已完成（{{ tab3 }}）</span>
        <audit ref="childRef4" :status="3" />
      </el-tab-pane> -->
      <el-tab-pane label="全部订单" name="order6">
        <span slot="label">全部订单（{{ orderCountObj.all }}）</span>
        <audit ref="childRef0" :status="-1" @customEvent="getOrderCount" />
      </el-tab-pane>
      <el-tab-pane label="待付款" name="order2">
        <span slot="label">待付款（{{ orderCountObj.waitPay }}）</span>
        <audit ref="childRef1" :status="0" @customEvent="getOrderCount" />
      </el-tab-pane>
      <el-tab-pane label="待审核" name="order1">
        <span slot="label">待审核（{{ orderCountObj.waitApprove }}）</span>
        <audit ref="childRef2" :status="6" @customEvent="getOrderCount" />
      </el-tab-pane>
      <el-tab-pane label="待发货" name="order3">
        <span slot="label">待发货（{{ orderCountObj.waitDelivery }}）</span>
        <audit ref="childRef3" :status="1" @customEvent="getOrderCount" />
      </el-tab-pane>
      <el-tab-pane label="待收货" name="order4">
        <span slot="label">待收货（{{ orderCountObj.delivered }}）</span>
        <audit ref="childRef4" :status="2" @customEvent="getOrderCount" />
      </el-tab-pane>
      <el-tab-pane label="已完成" name="order5">
        <span slot="label">已完成（{{ orderCountObj.completed }}）</span>
        <audit ref="childRef5" :status="3" @customEvent="getOrderCount" />
      </el-tab-pane>
      <el-tab-pane label="待评价" name="order7">
        <span slot="label">待评价（{{ orderCountObj.waitComment }}）</span>
        <!-- <evaluate ref="childRef6" :status="7" @customEvent="getOrderCount" /> -->
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import audit from './audit/audit.vue'
// import evaluate from './evaluate/index.vue'

import { mapState } from 'vuex'
import { orderCount } from '@/api/audit.js'
export default {
  name: 'MyOrder',
  components: {
    audit
    // evaluate
  },
  computed: {
    ...mapState(['tab0', 'tab1', 'tab2', 'tab3', 'tab4'])
  },
  data() {
    return {
      activeName: 'order6',
      status: '',
      orderCountObj: {}
    }
  },
  watch: {
    tab0: {
      handler: function(newV, oldV) {
        this.$refs.childRef0.getOrderList()
        this.$refs.childRef1.getOrderList()
        this.$refs.childRef2.getOrderList()
      },
      deep: true
    },
    tab1: {
      handler: function(newV, oldV) {
        this.$refs.childRef1.getOrderList()
        this.$refs.childRef2.getOrderList()
      },
      deep: true
    },
    tab2: {
      handler: function(newV, oldV) {
        this.$refs.childRef2.getOrderList()
        this.$refs.childRef3.getOrderList()
        this.$refs.childRef4.getOrderList()
      },
      deep: true
    },
    tab3: {
      handler: function(newV, oldV) {
        this.$refs.childRef1.getOrderList()
        this.$refs.childRef2.getOrderList()
        this.$refs.childRef3.getOrderList()
        this.$refs.childRef4.getOrderList()
        this.$refs.childRef0.getOrderList()
      },
      deep: true
    },
    tab4: {
      handler: function(newV, oldV) {
        this.$refs.childRef1.getOrderList()
        this.$refs.childRef2.getOrderList()
        this.$refs.childRef3.getOrderList()
        this.$refs.childRef4.getOrderList()
        this.$refs.childRef0.getOrderList()
      },
      deep: true
    }
  },
  created() {
    this.status = this.$route.params.val
    // this.status = this.$route.query.val;
    this.getStatus(this.status)
    this.getOrderCount()
  },
  methods: {
    handleClick(tab, event) {
      // console.log(tab, event, 'childRef' + [tab.index])
      if (tab.index === '6') {
        // this.$refs['childRef6'].getOrderList()
        this.$router.push({
          path: '/home/evaluate'
          // query: {
          //   id: row.id // 指定值或者获取的值
          // }
        })
      } else {
        this.$refs['childRef' + [tab.index]].getOrderList()
      }
    },
    getStatus(val) {
      // console.log('val', val)
      if (val === '待付款' || val === '0') {
        this.activeName = 'order2'
      } else if (val === '待发货' || val === '1') {
        this.activeName = 'order3'
      } else if (val === '待收货' || val === '2') {
        this.activeName = 'order4'
      } else if (val === '已完成' || val === '3') {
        this.activeName = 'order5'
      } else if (val === '待审核' || val === '6') {
        this.activeName = 'order1'
      } else if (val === '已关闭' || val === '4' || val === '-1') {
        this.activeName = 'order6'
      }
    },
    getOrderCount() {
      orderCount().then(res => {
        this.orderCountObj = res.data
        // console.log(res)
      })
    }
  }
}
</script>

<style scoped>
.page-size {
  margin: 15px 0px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
</style>
